// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  fileId: __t.u64().primaryKey().name("file_id"),
  versionId: __t.u64().name("version_id"),
  filename: __t.string(),
  relativePath: __t.string().name("relative_path"),
  isPrimary: __t.bool().name("is_primary"),
  sizeBytes: __t.u64().name("size_bytes"),
  hash: __t.string(),
  contentType: __t.string().name("content_type"),
  blobPath: __t.string().name("blob_path"),
  downloadUrl: __t.option(__t.string()).name("download_url"),
  chunkSize: __t.u32().name("chunk_size"),
  chunkCount: __t.u32().name("chunk_count"),
});
